export enum ScoringStatus {
    Success, Failure, Pending, Timeout
}